// @ts-nocheck: converted from JS

export const sexes = {
  m: 'Male',
  f: 'Female',
};
